import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-stone-50/95 backdrop-blur-sm border-b border-stone-300' : 'bg-transparent'}`} data-id="element-1052">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1053">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="font-serif text-xl tracking-tight text-stone-900" data-id="element-1054">
          BlockQuote
        </button>

        <div className="hidden md:flex items-center gap-8" data-id="element-1055">
          <button onClick={() => scrollTo('problem')} className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1056">
            Problem
          </button>
          <button onClick={() => scrollTo('solution')} className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1057">
            Solution
          </button>
          <button onClick={() => scrollTo('proof')} className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1058">
            Proof
          </button>
          <button onClick={() => scrollTo('pricing')} className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1059">
            Pricing
          </button>
          <Link to="/deck" className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1060">
            Deck
          </Link>
          <Link to="/agency" className="text-sm text-stone-500 hover:text-stone-900 transition-colors" data-id="element-1061">
            Agency Demo
          </Link>
        </div>

        <Link to="/app" className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 text-sm font-medium transition-colors" data-id="element-1062">
          Try Demo
          <ArrowRight className="w-4 h-4" data-id="element-1063" />
        </Link>
      </div>
    </motion.nav>;
}